import { useState, useCallback } from 'react';
import * as _ from 'lodash-es';
import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  TableSortLabel,
} from '@mui/material';

export function SimpleTable({
  sx,
  rows,
  size,
  stickyHeader,
  header = true,
  sortableColumns = {},
  onRowClick,
  hiddenColumns = [],
  ...passThrough
}) {
  const isVisible = useCallback(
    (k) => !hiddenColumns.includes(k),
    [hiddenColumns],
  );
  const [orderBy, setOrderBy] = useState(null);
  const [order, setOrder] = useState('asc');

  function handleSort(column) {
    if (orderBy === column) {
      setOrder(order === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(column);
      setOrder('asc');
    }
  }

  const sortedRows =
    orderBy != null
      ? _.orderBy(
          rows,
          [
            (row) => {
              const iteratee = sortableColumns[orderBy];
              const val = row[orderBy] ?? '';
              return typeof iteratee === 'function' ? iteratee(val) : val;
            },
          ],
          [order],
        )
      : rows;

  return (
    <TableContainer sx={sx} {...passThrough}>
      <Table size={size} stickyHeader={stickyHeader}>
        {header ? (
          <TableHead>
            <TableRow>
              {Object.keys(rows[0])
                .filter(isVisible)
                .map((headerCell, rowIndex) =>
                  headerCell in sortableColumns ? (
                    <TableCell
                      key={rowIndex}
                      sortDirection={orderBy === headerCell ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === headerCell}
                        direction={orderBy === headerCell ? order : 'asc'}
                        onClick={() => handleSort(headerCell)}
                      >
                        {headerCell}
                      </TableSortLabel>
                    </TableCell>
                  ) : (
                    <TableCell key={rowIndex}>{headerCell}</TableCell>
                  ),
                )}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {sortedRows.map((row, i) => (
            <TableRow
              key={i}
              selected={row.selected}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              sx={onRowClick ? { cursor: 'pointer' } : undefined}
            >
              {Object.entries(row)
                .filter(([k]) => isVisible(k))
                .map(([, cell], cellIndex) => (
                  <TableCell key={cellIndex}>{cell}</TableCell>
                ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
